import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionCeseTRADEByID = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionCeseTRADEByID = () => {
  const [loadingGetDeclaracionCeseTRADEByID, setLoadingDeclaracionCeseTRADEByID] = useState(false);
  const [successGetDeclaracionCeseTRADEByID, setSuccessDeclaracionCeseTRADEByID] = useState(false);
  const [errorGetDeclaracionCeseTRADEByID, setErrorDeclaracionCeseTRADEByID] = useState<any>(null);
  const [dataGetDeclaracionCeseTRADEByID, setDataDeclaracionCeseTRADE] = useState<any>(null);

  const [statusGetDeclaracionCeseTRADEByID, setStatusGetDeclaracionCeseTRADEByID] =
    useState<StatusGetDeclaracionCeseTRADEByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionCeseTRADEByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingDeclaracionCeseTRADEByID(true);
    setSuccessDeclaracionCeseTRADEByID(false);
    setErrorDeclaracionCeseTRADEByID(null);

    try {
      const res = await apiRecord.getSolicitudDeclaracionJuradaTradeByID(userId, prestacionId, id);

      setStatusGetDeclaracionCeseTRADEByID({
        status: res.status,
        statusText: res.statusText
      });

      setDataDeclaracionCeseTRADE(res.data);
      setSuccessDeclaracionCeseTRADEByID(true);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionCeseTRADEByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorDeclaracionCeseTRADEByID(err);
      console.error("Error en getDeclaracionCeseTRADEByID:", err);

      throw err;

    } finally {
      setLoadingDeclaracionCeseTRADEByID(false);
    }
  };

  return {
    getDeclaracionCeseTRADEByID,
    loadingGetDeclaracionCeseTRADEByID,
    successGetDeclaracionCeseTRADEByID,
    errorGetDeclaracionCeseTRADEByID,
    dataGetDeclaracionCeseTRADEByID,
    statusGetDeclaracionCeseTRADEByID
  };
};

export default useGetDeclaracionCeseTRADEByID;